import React, { ReactElement } from 'react';

import { LoginErrorState, LoginErrorType } from './store/LoginState';
import { Login as CoreLogin } from '@instinet-analytics/semantic-ui-components';
import { useDispatchSupportRequestAction } from 'app/contactSupport/store/dispatcher';
import { loginStateErrorAction } from 'login/store/actions';
import { useDispatch } from 'store/hooks';

interface LoginProps {
    loginDisabled?: boolean;
    error?: LoginErrorState;
    showContactSupport?: boolean;
    onSubmit: (username: string, password: string) => void;
    onReset: () => void;
}

export default function Login(props: LoginProps): ReactElement {
    const { loginDisabled, onSubmit, onReset, error, showContactSupport } =
        props;
    const dispatch = useDispatch();

    const dispatchSupportRequest = useDispatchSupportRequestAction();

    const onContactSupportClicked = showContactSupport
        ? (
              enquiryText: string,
              name: string | undefined,
              screenshot: string
          ) => {
              dispatchSupportRequest(enquiryText, name, screenshot);
          }
        : undefined;

    const onForgottenPasswordClicked = () =>
        dispatch(
            loginStateErrorAction({
                title: 'Forgotten password',
                type: LoginErrorType.USER_CONFIGURATION_ERROR,
                message:
                    'If you have forgotten your Indigo password, please contact your Instinet rep or email your regional support group.',
                innerError: {},
            })
        );

    return (
        <CoreLogin
            loginDisabled={loginDisabled}
            onSubmit={onSubmit}
            onReset={onReset}
            error={error}
            onContactSupportClicked={onContactSupportClicked}
            onForgottenPasswordClicked={onForgottenPasswordClicked}
        />
    );
}
